import { useQuery } from '@apollo/client'
import { GetHomeScreensDocument, GetHomeScreensQuery } from '~/__generated__/graphql'

export function useHomeVideoList() {
  const { data, error } = useQuery<GetHomeScreensQuery>(GetHomeScreensDocument)

  if (error) {
    // TODO: 将来的にエラーをdispatchして、エラー画面が出るようにする
    console.error(error)
    throw error
  }

  if (data === undefined) {
    return 'loading'
  }

  return data.homeScreens
}
